import { put, takeLatest } from 'redux-saga/effects';

import { setUnassignedFilter, setAssignedFilter, setFinishedFilter } from './duck';

const setFilters = {
  UNASSIGNED: setUnassignedFilter,
  ASSIGNED: setAssignedFilter,
  FINISHED: setFinishedFilter,
};

// @effect Action
export const filter$ = 'jobs/filter$';
export const resetFilter$ = 'jobs/resetFilter$';

// @effect Creators
export const filterJobs = (
  filters,
  { triggerFetch = true, realtime = true, section = '' } = {}
) => ({
  type: filter$,
  payload: { filters, triggerFetch, realtime, section },
});

// Workers
function* filter({ payload }) {
  const { filters, section } = payload;

  yield put(setFilters[section] && setFilters[section](filters));
}

// Watchers
export function* watchJobs() {
  yield takeLatest(filter$, filter);
}
